import React, { Component } from 'react';

class TranslateName extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <span>{this.props.language == 'ch' ? this.props.data.Description : this.props.data.Name}</span>;
  }
}

export default TranslateName;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/Translate.jsx